export default __webpack_public_path__ + "static/media/step2_2.293cb58d.png";